var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"photo-upload",class:{
    mask: _vm.showMask,
    disabled: _vm.disabled,
    'upload-success': _vm.uploadState === 4,
    'upload-error': _vm.uploadState === 5,
  },style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[(_vm.fileUrl)?_c('img',{attrs:{"src":_vm.fileUrl}}):_c('div',{ref:"file-upload",staticClass:"el-icon-plus",on:{"click":_vm.openFile}}),(_vm.showMask)?_c('i',{staticClass:"el-icon-delete",on:{"click":_vm.resetFile}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }